import React, {useEffect} from 'react';
import MaterialTable, { MTableActions } from "material-table";
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, createStyles, IconButton, makeStyles, MuiThemeProvider, Theme } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { useStores } from '../../_stores';
import { autorun } from 'mobx';
import { observer, useLocalStore } from 'mobx-react-lite';
import { IService } from '../../_types/interfaces';
import { Notification } from '../../core/Notification';
import { Description } from '@material-ui/icons';
import PatchNotes from '../PatchNotes/PatchNotes';
import theme from '../../core/TableTheme';
import { LicenseImport } from '../../core/LicenseImport';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            overflow: 'auto',
        },
        loading: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: 'rgba(0,0,0,0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        actions: {
            minWidth: '50vw', 
            minHeight:'60px', 
            marginTop: '30px', 
            display:'flex', 
            flexDirection:'row-reverse',
        },
        update: {
            marginRight: '20px',
            maxHeight: 30
        },
        storage: {
            marginRight:'20px', 
            fontWeight:600,
            paddingTop: '18px',
        },
        progress: {
            minWidth: '40%', 
            paddingTop:'14px',
        },
        title:
        {
            align: 'left',
            display: 'flex',
            marginLeft: '1%'
        },
    })
);

const Indiv = observer(() => {
    const classes = useStyles();
    const {updateStore, patchNotesStore, importStore} = useStores();
    
    const materialTableRef = React.createRef<any>();

    const state = useLocalStore(() => ({
        isOpen: false,
        isImportLicense: false,
    }));

    const {t} = useTranslation();
    const translate = (variable: string) => {
        return t('updates.' + variable);
    };

    const OnRowSelect = (props: any) => {
        const update = async () => {
            // убрать выделение
            if (materialTableRef.current)
                materialTableRef.current.onAllSelected(false);

            await updateStore.downloadFiles((props.data as Array<IService>).map(d => d.name));
        }

        return (
            <div className={classes.actions}>
                <Button 
                    startIcon={<SystemUpdateAltIcon/>} 
                    className={classes.update}
                    size={"large"}
                    onClick={async () => await update()}
                >
                    {translate("update")}
                </Button>
            </div>
        );
    };

    useEffect(() => {
        autorun(async () => {
            await updateStore.loadServices();
        });
    }, []);

    return (
        <div>
            {
                updateStore.loading &&
                <div className={classes.loading}> <CircularProgress disableShrink/> </div>
            }
            <h2 className = {classes.title}>{translate("title")}</h2>
            <MuiThemeProvider theme={theme}>
                <MaterialTable
                    localization={t('tables', {returnObjects: true})}
                    title={''}
                    
                    columns={[
                        {field: 'name', title: translate("columns.name")},
                        {field: 'version', title: translate("columns.version")},
                        {field: 'download', title: translate("columns.download")},
                        {field: 'file', title: t('patchNotes.patchNote'), 
                            cellStyle: { width: '10%', }, 
                            render: rowData => (
                            <IconButton 
                                style = {{marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                                onClick = { async () => {
                                    await patchNotesStore.loadLocalPatchNotes(rowData.name);
                                    state.isOpen = true; 
                                    }}>
                                <Description/>
                            </IconButton>)
                        },
                    ]}
                    data={updateStore.services}
                    actions={[
                        {
                            icon: 'system_update_alt',
                            tooltip: translate('columns.send_request_download'),
                            isFreeAction: true,
                            onClick: async () => updateStore.sendRequestDownloadService(),
                        },
                    ]}
                    options={{
                        search: false,
                        selection: true,
                        paging: false,
                    }}
                    components={{
                        Actions: props => {
                            // Отрисовка, если есть данные
                            if (props.hasOwnProperty('data'))
                                return <OnRowSelect {...props}/>
                            return <MTableActions {...props} /> 
                        },
                    }}
                    tableRef={materialTableRef}
                />
                </MuiThemeProvider>
            <Notification
                isOpen={updateStore.isNotification}
                close={() => updateStore.isNotification = false}
                okClick={() => updateStore.isNotification = false}
                questionText={updateStore.message}
            />
            <PatchNotes
                isOpen={state.isOpen}
                close={() => state.isOpen = false}
            />
        </div>
    )
});

export default Indiv;

